const RELOAD_KEY = "chunk-reload-at";
const RELOAD_WINDOW_MS = 60_000;

const isChunkError = (e: unknown): boolean =>
  e instanceof Error &&
  /ChunkLoadError|Loading chunk \d+ failed|dynamically imported module|Importing a module script failed/i.test(
    e.message,
  );

const reloadOnce = (): void => {
  const lastReloadAt = Number(sessionStorage.getItem(RELOAD_KEY));
  if (Date.now() - lastReloadAt < RELOAD_WINDOW_MS) return;
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  window.location.reload();
};

export { isChunkError, reloadOnce };
